import { useEffect, useMemo } from "react";
import FAQItem from "../FAQItem/FAQItem.tsx";
import "./FAQList.css";
import { IFAQAll, IFAQFileAll } from "@/types/SPTypes.tsx";
import { useAppSelector } from "@/hooks/storeHooks.ts";
import { isIFAQFile, isIFAQFileGuest } from "@/types/typeGuards.ts";

const FAQList = ({ FAQData }: { FAQData: IFAQAll[] }) => {
  const FAQFiles = useAppSelector(state => state.application.FAQFiles);
  const isLoggedIn = useAppSelector(state => state.application.isLoggedIn);

  const filesByFaqId = useMemo(() => {
    const filesGrouped: Record<string, IFAQFileAll[]> = {};

    for (const file of FAQFiles ?? []) {
      const faqId = isIFAQFileGuest(file)
        ? String(file.belongsToFAQ) // number
        : isIFAQFile(file)
        ? String(file.belongsToFAQ.ID) // object with ID
        : undefined;

      if (!faqId) continue;
      (filesGrouped[faqId] ??= []).push(file);
    }

    return filesGrouped;
  }, [FAQFiles]);

  // if linking to specific FAQ
  useEffect(() => {
    const hash = window.location.hash;
    // Extract the part after the second # if it exists:
    let FAQId: string | null = null;
    const urlParts = hash.split("#");
    if (urlParts.length === 3) {
      FAQId = urlParts[2]; // e.g. "faq-226"
    }

    if (FAQId) {
      // if faq ID is in the url, find the faq and scroll to it
      const element = document.getElementById(FAQId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
        // clear the ID to be able to link to other FAQ's with clean path
        window.history.replaceState({}, "", "#/FAQs");
      }
    }
  }, [FAQData]); // run after FAQData is rendered

  if (FAQData.length === 0) {
    return (
      <div className="no-FAQs-found-container">
        <b>Inga FAQ:er hittades...</b>
      </div>
    );
  }

  return (
    <div>
      {FAQData.map(FAQ => {
        const FAQId = isLoggedIn ? FAQ.ID : FAQ.vsdlId;
        const filesForThisFaq = filesByFaqId[FAQId] ?? [];
        return (
          <FAQItem key={String(FAQId)} FAQ={FAQ} FAQFiles={filesForThisFaq} />
        );
      })}
    </div>
  );
};

export default FAQList;
